import MondayIntegration from './MondayIntegration';
export default MondayIntegration;
